/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_How_Step3_DescInputs */

const en_landing_how_step3_desc = /** @type {(inputs: Landing_How_Step3_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download your tailored resume, generate a cover letter, and track every application in one dashboard.`)
};

const de_landing_how_step3_desc = /** @type {(inputs: Landing_How_Step3_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lade deinen angepassten Lebenslauf herunter, erstelle ein Anschreiben und verfolge jede Bewerbung in einem Dashboard.`)
};

const fr_landing_how_step3_desc = /** @type {(inputs: Landing_How_Step3_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Télécharge ton CV adapté, génère une lettre de motivation et suis chaque candidature depuis un seul tableau de bord.`)
};

const es_landing_how_step3_desc = /** @type {(inputs: Landing_How_Step3_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descarga tu currículum adaptado, genera una carta de presentación y haz seguimiento de todas tus solicitudes en un solo panel.`)
};

const it_landing_how_step3_desc = /** @type {(inputs: Landing_How_Step3_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scarica il curriculum personalizzato, genera una lettera di presentazione e monitora tutte le candidature in un'unica dashboard.`)
};

const nl_landing_how_step3_desc = /** @type {(inputs: Landing_How_Step3_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download je aangepaste CV, genereer een motivatiebrief en volg al je sollicitaties in één dashboard.`)
};

const pl_landing_how_step3_desc = /** @type {(inputs: Landing_How_Step3_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pobierz dopasowane CV, wygeneruj list motywacyjny i śledź każdą aplikację w jednym panelu.`)
};

const fi_landing_how_step3_desc = /** @type {(inputs: Landing_How_Step3_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lataa räätälöity ansioluettelo, luo saatekirje ja seuraa kaikkia hakemuksia yhdessä paikassa.`)
};

const da_landing_how_step3_desc = /** @type {(inputs: Landing_How_Step3_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download dit tilpassede CV, generer et ansøgningsbrev og spor alle ansøgninger i ét dashboard.`)
};

const sv_landing_how_step3_desc = /** @type {(inputs: Landing_How_Step3_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ladda ner ditt anpassade CV, generera ett personligt brev och spåra varje ansökan i en instrumentpanel.`)
};

/**
* | output |
* | --- |
* | "Download your tailored resume, generate a cover letter, and track every application in one dashboard." |
*
* @param {Landing_How_Step3_DescInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const landing_how_step3_desc = /** @type {((inputs?: Landing_How_Step3_DescInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_How_Step3_DescInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_landing_how_step3_desc(inputs)
	if (locale === "fr") return fr_landing_how_step3_desc(inputs)
	if (locale === "es") return es_landing_how_step3_desc(inputs)
	if (locale === "it") return it_landing_how_step3_desc(inputs)
	if (locale === "nl") return nl_landing_how_step3_desc(inputs)
	if (locale === "pl") return pl_landing_how_step3_desc(inputs)
	if (locale === "fi") return fi_landing_how_step3_desc(inputs)
	if (locale === "da") return da_landing_how_step3_desc(inputs)
	if (locale === "sv") return sv_landing_how_step3_desc(inputs)
	return en_landing_how_step3_desc(inputs)
});